import type { FunctionComponent } from 'react'

/**
 * Copy icon.
 * Based on LiaCopy from https://react-icons.github.io/react-icons/icons/lia/
 */
const CopyIcon: FunctionComponent = () => {
  return (
    <>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 30 30"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M 4 4 L 4 24 L 11 24 L 11 22 L 6 22 L 6 6 L 18 6 L 18 7 L 20 7 L 20 4 Z M 12 8 L 12 28 L 28 28 L 28 8 Z M 14 10 L 26 10 L 26 26 L 14 26 Z"></path>
      </svg>
    </>
  )
}

export default CopyIcon
